import React from "react";
import "./LevelRing.css";

// Points levels (founder 10/29, look A — client/.claude/fan-star-levels.html):
// a coloured ring around a fan's photo with the level number on its corner.
// One level per 1,000 points EARNED (server lib/fanPoints.js levelFor), so a
// Fan Boost never takes it away. Green → blue → purple → pink, then a
// rainbow ring from level 5 on; never gold (gold = Fan Boost on the DJ's
// screen). Level 0 (or an older server with no level) = the photo as it is.
const LevelRing: React.FC<{ level?: number | null; hideNumber?: boolean; children: React.ReactNode }> = ({ level, hideNumber, children }) => {
  const n = Math.floor(Number(level) || 0);
  if (n < 1) return <>{children}</>;
  return (
    <span className={`lvring lvring--${Math.min(n, 5)}`}>
      {children}
      {!hideNumber && (
        <span className={`lvring-num${n >= 100 ? " lvring-num--3" : n >= 10 ? " lvring-num--2" : ""}`} aria-hidden="true">{n}</span>
      )}
    </span>
  );
};

export default LevelRing;
